import { render, staticRenderFns } from "./HistoryResult.vue?vue&type=template&id=23472d01&"
import script from "./HistoryResult.vue?vue&type=script&lang=js&"
export * from "./HistoryResult.vue?vue&type=script&lang=js&"
import style0 from "./HistoryResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports